import { render } from "./trainingVideo.vue?vue&type=template&id=0b945246"
import script from "./trainingVideo.vue?vue&type=script&lang=js"
export * from "./trainingVideo.vue?vue&type=script&lang=js"

import "./trainingVideo.vue?vue&type=style&index=0&id=0b945246&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__